export default "__VITE_ASSET__Bgcc0Plj__"